import React, { useEffect, useState } from 'react'
import { useBlogsHook } from '../useBlogsHook'
import BlogListComponent from './BlogListComponent';
import InfiniteScrollSentinel from './InfiniteScrollSentinel';

export default function ListBlogs() {
    const {
        fetchAllBlogs,
        fetchMoreBlogs,
        searchBlogs,
        blogs,
        blogsLoading,
        loadingMore,
        hasMoreBlogs,
    } = useBlogsHook();
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        fetchAllBlogs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (searchQuery.trim() === '') {
            fetchAllBlogs();
        } else if (searchQuery.trim().length >= 3) {
            const delaySearch = setTimeout(() => {
                searchBlogs(searchQuery);
            }, 500); // 500ms debounce

            return () => clearTimeout(delaySearch);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery]);

    if (blogsLoading === true || blogs === null) {
        return <div>Loading...</div>
    };
    return (
        <div className='flex justify-center items-center flex-col'>
            <h1 className='text-2xl font-bold my-8'>
                List All Blogs
            </h1>
            
            {/* Search Input */}
            <div className='w-full max-w-2xl my-4 px-4'>
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search blogs... (min. 3 characters)"
                    className='w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                />
                {searchQuery.trim().length > 0 && searchQuery.trim().length < 3 && (
                    <p className='text-sm text-gray-500 mt-1'>Please enter at least 3 characters to search</p>
                )}
            </div>

            {
                blogs.map((blog: any) => {
                    return (
                        <BlogListComponent
                            key={blog._id}
                            mode='list'
                            _id={blog._id}
                            blogContent={blog.blogDescription1}
                            blogCreatedAt={blog.blogCreatedAt}
                            blogImage={blog.blogImage1}
                            blogReadCount={blog.blogReadCount}
                            blogTitle={blog.blogTitle1}
                            blogTrimester={blog.blogTrimester}
                            blogUpdatedAt={blog.blogUpdatedAt}
                            isDeleted={blog.isDeleted}
                            isPriority={blog.isPriority}
                            recipeReferences={blog.recipeReferences}
                            relatedData={blog.relatedData}
                            open={false}
                            setOpen={() => { }}
                        />
                    )
                })
            }
            {searchQuery.trim() === '' && hasMoreBlogs && (
                <>
                    <InfiniteScrollSentinel
                        onLoadMore={fetchMoreBlogs}
                        disabled={loadingMore}
                    />
                    {loadingMore && <p className="py-4 text-gray-500">Daha fazla yükleniyor...</p>}
                </>
            )}
        </div>
    )
}
